import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Layout from '../common/Layout';

const UploadDocument = () => {
    const masterTypeMap = {
        mmv: 'mmv',
        rto: 'rto',
        pincode: 'pincode',
        occupation: 'occupation',
        relation: 'relation',
        kit: 'kit',
        kyc: 'kyc',
        financier: 'financier',
        financer: 'financier',
        previnsurer: 'previous-insurer',
        previousinsurer: 'previous-insurer',
        exshowroom: 'exshowroom',
        showroom: 'exshowroom',
        salutation: 'salutation',
    };
    const extensionToSourceType = {
        '.pdf': 'pdf',
        '.zip': 'zip',
        '.xlsx': 'xlsx',
        '.xls': 'xls',
        '.csv': 'csv',
        '.doc': 'doc',
        '.docx': 'docx',
    };
    const [sourceType, setSourceType] = useState('');
    const [documentType, setDocumentType] = useState('');
    const [insurer, setInsurer] = useState('');

    const [selectedFile, setSelectedFile] =
        useState(null);

    const [loading, setLoading] =
        useState(false);
    const handleFileChange = (e) => {
        const file = e.target.files?.[0];

        if (!file) {
            setSelectedFile(null);
            return;
        }

        const fileName = file.name.toLowerCase();

        const extension =
            '.' +
            fileName
                .split('.')
                .pop();
        const allowedExtensions =
            Object.keys(
                extensionToSourceType
            );

        if (
            !allowedExtensions.includes(
                extension
            )
        ) {
            toast.error(
                'File type not allowed. Please select PDF, ZIP, XLS, XLSX, CSV, DOC or DOCX file.'
            );

            e.target.value = '';

            setSelectedFile(null);

            return;
        }
        if (
            documentType &&
            extensionToSourceType[
            extension
            ] !== documentType
        ) {
            toast.error(
                `Please select a ${documentType.toUpperCase()} file.`
            );

            e.target.value = '';

            setSelectedFile(null);

            return;
        }

        setSelectedFile(file);
        const detectedDocumentType =
            extensionToSourceType[
            extension
            ];

        if (detectedDocumentType) {
            setDocumentType(
                detectedDocumentType
            );
        }
    };
    const handleDocumentTypeChange = (
        value
    ) => {
        setDocumentType(value);
        if (selectedFile && value) {
            const extension =
                '.' +
                selectedFile.name
                    .split('.')
                    .pop()
                    .toLowerCase();

            const selectedFileType =
                extensionToSourceType[
                extension
                ];

            if (
                selectedFileType !== value
            ) {
                toast.warning(
                    `Selected file is ${selectedFileType?.toUpperCase() || 'different type'}. Please select a ${value.toUpperCase()} file.`
                );

                setSelectedFile(null);
            }
        }
    };
    const handleSourceTypeChange = (
        value
    ) => {
        setSourceType(value);
    };
    const handleUpload = async () => {
        if (!insurer.trim()) {
            toast.error(
                'Please enter insurer'
            );
            return;
        }

        if (!sourceType) {
            toast.error(
                'Please select Source Type'
            );
            return;
        }

        if (!documentType) {
            toast.error(
                'Please select Document Type'
            );
            return;
        }

        if (!selectedFile) {
            toast.error(
                'Please select a file'
            );
            return;
        }
        const extension =
            '.' +
            selectedFile.name
                .split('.')
                .pop()
                .toLowerCase();

        const detectedDocumentType =
            extensionToSourceType[
            extension
            ];

        if (
            detectedDocumentType !==
            documentType
        ) {
            toast.error(
                `Document type does not match selected file.`
            );
            return;
        }
        const formData = new FormData();

        formData.append(
            'file',
            selectedFile
        );

        // Source Type
        formData.append(
            'sourceType',
            sourceType
        );

        // Document Type
        formData.append(
            'documentType',
            documentType
        );

        // Insurer
        formData.append(
            'insurer',
            insurer.trim()
        );

        for (const [
            key,
            value,
        ] of formData.entries()) {
            console.log(
                key,
                value
            );
        }
        try {
            setLoading(true);

            const token =
                localStorage.getItem(
                    'accessToken'
                );

            const response =
                await fetch(
                    'https://uatmasterapi.flaskitsolutions.com/s3/upload-document',
                    {
                        method: 'POST',

                        headers: {
                            Authorization: `Bearer ${token}`,
                        },

                        body: formData,
                    }
                );

            const data =
                await response.json();

            console.log(
                'Upload Response:',
                data
            );

            if (response.ok) {
                toast.success(
                    data?.message ||
                    'Uploaded successfully'
                );
                setSourceType('');
                setDocumentType('');
                setInsurer('');
                setSelectedFile(null);
                const fileInput =
                    document.getElementById(
                        'uploadFile'
                    );

                if (fileInput) {
                    fileInput.value =
                        '';
                }
            } else {
                toast.error(
                    data?.message ||
                    data?.displayMessage ||
                    'Upload failed'
                );
            }
        } catch (error) {
            console.error(
                'Upload Error:',
                error
            );

            toast.error(
                error?.message ||
                'Upload error'
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>

            <div className="mt-7 mx-4">

                <div className="card">

                    <div className="card-header">
                        <h5 className="mb-0">
                            Upload Document
                        </h5>
                    </div>

                    <div className="card-body">

                        <div className="row">
                            <div className="col-md-4">

                                <label className="form-label">
                                    Insurer{' '}
                                    <span className="text-danger">
                                        *
                                    </span>
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="e.g. digit"
                                    value={insurer}
                                    onChange={(e) =>
                                        setInsurer(
                                            e.target.value
                                        )
                                    }
                                    disabled={
                                        loading
                                    }
                                />

                            </div>
                            <div className="col-md-4">

                                <label className="form-label">
                                    Document Type{' '}
                                    <span className="text-danger">
                                        *
                                    </span>
                                </label>

                                <select
                                    className="form-control"
                                    value={
                                        documentType
                                    }
                                    onChange={(e) =>
                                        handleDocumentTypeChange(
                                            e.target.value
                                        )
                                    }
                                    disabled={
                                        loading
                                    }
                                >

                                    <option value="">
                                        Select Document Type
                                    </option>

                                    {Object.entries(
                                        extensionToSourceType
                                    ).map(
                                        ([
                                            extension,
                                            value,
                                        ]) => (
                                            <option
                                                key={
                                                    extension
                                                }
                                                value={
                                                    value
                                                }
                                            >
                                                {value.toUpperCase()}
                                            </option>
                                        )
                                    )}

                                </select>

                            </div>
                            <div className="col-md-4">

                                <label className="form-label">
                                    Mater Type{' '}
                                    <span className="text-danger">
                                        *
                                    </span>
                                </label>

                                <select
                                    className="form-control"
                                    value={
                                        sourceType
                                    }
                                    onChange={(e) =>
                                        handleSourceTypeChange(
                                            e.target.value
                                        )
                                    }
                                    disabled={
                                        loading
                                    }
                                >

                                    <option value="">
                                        Select Source Type
                                    </option>

                                    {Object.entries(
                                        masterTypeMap
                                    )

                                        .filter(
                                            (
                                                [
                                                    key,
                                                    value,
                                                ],
                                                index,
                                                array
                                            ) =>
                                                array.findIndex(
                                                    (item) =>
                                                        item[1] ===
                                                        value
                                                ) ===
                                                index
                                        )
                                        .map(
                                            ([
                                                key,
                                                value,
                                            ]) => (
                                                <option
                                                    key={
                                                        key
                                                    }
                                                    value={
                                                        value
                                                    }
                                                >
                                                    {value}
                                                </option>
                                            )
                                        )}

                                </select>

                            </div>
                            <div className="col-md-4 mt-3">

                                <label className="form-label">
                                    File{' '}
                                    <span className="text-danger">
                                        *
                                    </span>
                                </label>

                                <input
                                    id="uploadFile"
                                    type="file"
                                    className="form-control"
                                    accept=".pdf,.zip,.xlsx,.xls,.csv,.doc,.docx"
                                    onChange={
                                        handleFileChange
                                    }
                                    disabled={
                                        loading
                                    }
                                />

                                {selectedFile && (
                                    <small className="text-success d-block mt-2">
                                        Selected:{' '}
                                        {
                                            selectedFile.name
                                        }
                                    </small>
                                )}

                            </div>
                            <div className="col-md-4 mt-3 d-flex align-items-end">

                                <button
                                    type="button"
                                    className="btn btn-sec w-100"
                                    onClick={
                                        handleUpload
                                    }
                                    disabled={
                                        loading
                                    }
                                >

                                    {loading
                                        ? 'Uploading...'
                                        : 'Upload'}

                                </button>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

            {loading && (
                <div
                    className="loader-overlay"
                    style={{
                        position:
                            'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background:
                            'rgba(0,0,0,0.5)',
                        display:
                            'flex',
                        alignItems:
                            'center',
                        justifyContent:
                            'center',
                        zIndex: 9999,
                    }}
                >

                    <div className="text-center text-white">

                        <div
                            className="spinner-border text-light"
                            role="status"
                        />

                        <h5 className="mt-3">
                            Uploading Document...
                        </h5>

                        <p className="mb-0">
                            Please wait...
                        </p>

                    </div>

                </div>
            )}

        </Layout>
    );
};

export default UploadDocument;